(() => {
  'use strict';
  if (!window.customElements || customElements.get('fs-chart-dialog')) return;

  const candidates = 'product-info .product__accordion summary, product-info modal-opener[data-modal] button, .fs-pdp-lower .product__accordion summary, .fs-pdp-lower modal-opener[data-modal] button, fs-live-quickview .fs-live-quickview__detail > summary, fs-bundle-product .fs-bundle-product__detail > summary';
  const chartLabel = (value) => /\b(?:size|sizing)\s+(?:chart|guide)\b/i.test(String(value || ''));
  const cleanText = (value) => String(value || '').replace(/\s+/g, ' ').trim();
  const safeURL = (value) => {
    try {
      const url = new URL(value || '', document.baseURI || location.href);
      return value && url.protocol === 'https:' ? url.href : '';
    } catch (_) { return ''; }
  };
  const allowedTags = new Set(['P', 'DIV', 'SECTION', 'SPAN', 'STRONG', 'B', 'EM', 'I', 'U', 'S', 'BR', 'HR', 'UL', 'OL', 'LI', 'DL', 'DT', 'DD', 'H1', 'H2', 'H3', 'H4', 'H5', 'H6', 'TABLE', 'THEAD', 'TBODY', 'TFOOT', 'TR', 'TH', 'TD', 'CAPTION', 'FIGURE', 'FIGCAPTION', 'IMG', 'BLOCKQUOTE', 'SUP', 'SUB', 'A']);
  const blockedTags = new Set(['SCRIPT', 'STYLE', 'IFRAME', 'OBJECT', 'EMBED', 'FORM', 'INPUT', 'SELECT', 'TEXTAREA', 'BUTTON', 'TEMPLATE', 'NOSCRIPT', 'SVG', 'MATH', 'LINK', 'META']);


  // Exact, independently audited image identities only. No product/category fallback.
  // Printed source rows remain unchanged. Hoodie XS is separately store-confirmed.
  const nativeCharts = {"https://cdn.shopify.com/s/files/1/0716/8553/8021/files/TSHIRT.jpg":{"version":"1737657943","sourceTitleExact":["OVERSIZED T-SHIRT","UNISEX FIT"],"headersExact":["SIZE","CHEST","LENGTH","SHOULDERS"],"printedRowsExact":[["S",21,26,24],["M",22,27,25],["L",23,28,26],["XL",24,29,27]],"unitStatementExact":"ALL MEASUREMENTS ARE IN INCHES","notesExact":["Note: The size help refers to the product measurements which may slightly vary according to design"]},"https://cdn.shopify.com/s/files/1/0716/8553/8021/files/FULLSTOP_a8185312-ec29-4680-8b99-d7f4db4262bf.jpg":{"version":"1764665410","sourceTitleExact":["HOODIES & SWEATSHIRT","UNISEX FIT"],"headersExact":["SIZE","CHEST","LENGTH"],"printedRowsExact":[["S",22,25.5],["M",23,26.5],["L",24,27.5],["XL",25,28.5]],"unitStatementExact":"ALL MEASUREMENTS ARE IN INCHES","notesExact":["Note: The size help refers to the product measurements which may slightly vary according to design"],"confirmedAdditionalRows":[["XS",21,24.5]],"measurementGuide":"hoodie"},"https://cdn.shopify.com/s/files/1/0716/8553/8021/files/TSHIRT_4.png":{"version":"1737705456","sourceTitleExact":["TROUSER & SWEATPANTS","UNISEX FIT"],"headersExact":["SIZE","WAIST","LENGTH","THIGHS"],"printedRowsExact":[["S","26-28",39,12],["M","30-32",40,13],["L","32-34",41,14],["XL","34-36",42,15]],"unitStatementExact":"ALL MEASUREMENTS ARE IN INCHES","notesExact":["Note: The size help refers to the product measurements which may slightly vary according to design"]},"https://cdn.shopify.com/s/files/1/0716/8553/8021/files/TSHIRT_2.jpg":{"version":"1737823548","sourceTitleExact":["CropTop","Baby-Tee"],"headersExact":["SIZE","CHEST","LENGTH"],"printedRowsExact":[["XS",21,16],["S",22,17],["M",23,18],["L",24,19]],"unitStatementExact":"ALL MEASUREMENTS ARE IN INCHES","notesExact":["Note: The size help refers to the product measurements which may slightly vary according to design"]},"https://cdn.shopify.com/s/files/1/0716/8553/8021/files/FULLSTOP_2.png":{"version":"1751278248","sourceTitleExact":["SHORTS","UNISEX FIT"],"headersExact":["SIZE","WAIST","CUFF"],"printedRowsExact":[["S","26-29","17-19"],["M","29-33","19-21"],["L","33-37","21-23"]],"unitStatementExact":"ALL MEASUREMENTS ARE IN INCHES","notesExact":["Note: The size help refers to the product measurements which may slightly vary according to design"]},"https://cdn.shopify.com/s/files/1/0716/8553/8021/files/FULLSTOP_1_cd3f8a72-ea23-41eb-8218-cb4a55486264.png":{"version":"1770497512","sourceTitleExact":["RELAXED FIT SHIRT","UNISEX FIT"],"headersExact":["SIZE","CHEST","LENGTH"],"printedRowsExact":[["S",21,26],["M",22,27],["L",23,28],["XL",24,29]],"unitStatementExact":"ALL MEASUREMENTS ARE IN INCHES","notesExact":["Note: The size help refers to the product measurements which may slightly vary according to design"]},"https://cdn.shopify.com/s/files/1/0716/8553/8021/files/FULLSTOP.svg":{"version":"1763638806","sourceTitleExact":["HOODIES & SWEATSHIRT","UNISEX FIT"],"headersExact":["SIZE","CHEST","LENGTH"],"printedRowsExact":[["S",20,25.5],["M",21,26.5],["L",22,27.5],["XL",23,28.5]],"unitStatementExact":"ALL MEASUREMENTS ARE IN INCHES","notesExact":["Note: The size help refers to the product measurements which may slightly vary according to design"]},"https://cdn.shopify.com/s/files/1/0716/8553/8021/files/FULLSTOP_1.svg":{"version":"1780235395","sourceTitleExact":["TANK TOP FIT"],"headersExact":["SIZE","CHEST","LENGTH"],"printedRowsExact":[["S",null,28],["M",23,28.5],["L",24,29],["XL",24.5,30]],"unitStatementExact":null,"notesExact":["Note: The size help refers to the product measurements which may slightly vary according to design"]}};
  const nativeChartFor = (value) => {
    try {
      const url = new URL(value, document.baseURI || location.href);
      if (url.protocol !== 'https:' || url.username || url.password || url.hash) return null;
      const key = url.origin + url.pathname;
      const chart = Object.prototype.hasOwnProperty.call(nativeCharts, key) ? nativeCharts[key] : null;
      if (!chart || url.searchParams.getAll('v').length !== 1 || url.searchParams.get('v') !== chart.version) return null;
      if (Array.from(url.searchParams.keys()).some((name) => !['v', 'width', 'height', 'crop', 'format'].includes(name))) return null;
      return { chart, originalURL: key + '?v=' + encodeURIComponent(chart.version) };
    } catch (_) { return null; }
  };

  class FsChartDialog extends HTMLElement {
    connectedCallback() {
      if (this.connected) return;
      this.dialog = this.querySelector('dialog');
      if (!this.dialog || typeof this.dialog.showModal !== 'function') return;
      this.connected = true;
      this.descriptionId = this.dialog.getAttribute('aria-describedby');
      this.content = this.el('content');
      this.scroll = this.el('scroll');
      this.closeButton = this.querySelector('[data-fs-chart-close]');
      this.onDocumentClick = (event) => {
        if (event.defaultPrevented || (typeof event.button === 'number' && event.button !== 0)) return;
        const trigger = event.target?.closest?.(candidates);
        if (!trigger || !this.detailType(trigger)) return;
        if (!this.open(trigger)) return;
        event.preventDefault();
        // Stop Dawn's original opener only after this dialog has opened successfully.
        event.stopImmediatePropagation();
      };
      this.onClick = (event) => {
        if (event.target.closest('[data-fs-chart-close]')) this.close();
        if (event.target === this.dialog && this.backdropStart && this.outside(event)) this.close();
        this.backdropStart = false;
      };
      this.onPointerDown = (event) => { this.backdropStart = event.target === this.dialog && this.outside(event); };
      this.onPointerCancel = () => { this.backdropStart = false; };
      this.onCancel = (event) => { event.preventDefault(); this.close(); };
      this.onClose = () => this.finishClose();
      this.onKeyDown = (event) => {
        if (event.key !== 'Tab') return;
        const focusable = Array.from(this.dialog.querySelectorAll('button:not([disabled]), a[href], iframe, [tabindex]:not([tabindex="-1"])'))
          .filter((node) => !node.closest('[hidden]') && node.getClientRects().length);
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        const current = this.ownerDocument.activeElement;
        if (!first) { event.preventDefault(); this.closeButton.focus(); return; }
        if (event.shiftKey && (current === first || !this.dialog.contains(current))) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && (current === last || !this.dialog.contains(current))) { event.preventDefault(); first.focus(); }
      };
      this.onParentClose = () => this.close(false);
      this.onHistory = () => this.close();
      this.ownerDocument.addEventListener('click', this.onDocumentClick, true);
      this.dialog.addEventListener('click', this.onClick);
      this.dialog.addEventListener('pointerdown', this.onPointerDown);
      this.dialog.addEventListener('pointercancel', this.onPointerCancel);
      this.dialog.addEventListener('cancel', this.onCancel);
      this.dialog.addEventListener('close', this.onClose);
      this.dialog.addEventListener('keydown', this.onKeyDown);
      window.addEventListener('popstate', this.onHistory);
      this.enhance(this.ownerDocument);
      if (typeof MutationObserver === 'function') {
        this.observer = new MutationObserver((records) => {
          records.forEach((record) => {
            if (this.contains(record.target)) return;
            record.addedNodes.forEach((node) => { if (node.nodeType === 1) this.enhance(node); });
          });
          if (this.dialog.open && this.opener && !this.opener.isConnected) this.close(false);
        });
        this.observer.observe(this.ownerDocument.body, { childList: true, subtree: true });
      }
    }

    disconnectedCallback() {
      if (!this.connected) return;
      this.close(false);
      this.finishClose();
      this.observer?.disconnect();
      this.ownerDocument.removeEventListener('click', this.onDocumentClick, true);
      this.dialog.removeEventListener('click', this.onClick);
      this.dialog.removeEventListener('pointerdown', this.onPointerDown);
      this.dialog.removeEventListener('pointercancel', this.onPointerCancel);
      this.dialog.removeEventListener('cancel', this.onCancel);
      this.dialog.removeEventListener('close', this.onClose);
      this.dialog.removeEventListener('keydown', this.onKeyDown);
      window.removeEventListener('popstate', this.onHistory);
      this.ownerDocument.querySelectorAll('.fs-chart-trigger').forEach((trigger) => this.restoreTrigger(trigger));
      this.connected = false;
    }

    el(name) { return this.querySelector('[data-fs-chart-' + name + ']'); }
    enhance(root) {
      const triggers = Array.from(root.querySelectorAll(candidates));
      if (root.matches?.(candidates)) triggers.unshift(root);
      triggers.forEach((trigger) => {
        if (!this.detailType(trigger) || !this.sourceFor(trigger) || trigger.classList.contains('fs-chart-trigger')) return;
        trigger._fsChartAttributes = { haspopup: trigger.getAttribute('aria-haspopup'), controls: trigger.getAttribute('aria-controls') };
        trigger.classList.add('fs-chart-trigger');
        trigger.setAttribute('aria-haspopup', 'dialog');
        trigger.setAttribute('aria-controls', this.dialog.id);
      });
    }
    restoreTrigger(trigger) {
      const original = trigger._fsChartAttributes;
      if (!original) return;
      ['haspopup', 'controls'].forEach((key) => {
        if (original[key] === null) trigger.removeAttribute('aria-' + key);
        else trigger.setAttribute('aria-' + key, original[key]);
      });
      trigger.classList.remove('fs-chart-trigger');
      delete trigger._fsChartAttributes;
    }
    isPDP(trigger) {
      return !trigger.closest('fs-live-quickview, fs-bundle-product') && Boolean(trigger.closest('product-info, .fs-pdp-lower'));
    }
    detailType(trigger) {
      if (chartLabel(trigger.textContent)) return 'chart';
      return this.isPDP(trigger) && trigger.tagName === 'SUMMARY' && /^material$/i.test(cleanText(trigger.textContent)) ? 'material' : '';
    }
    sourceFor(trigger) {
      const details = trigger.closest('details');
      if (trigger.tagName === 'SUMMARY' && details) {
        // This content was rendered by the selected product template. No category fallback.
        return Array.from(details.children).find((child) => child.matches('.accordion__content, .fs-live-quickview__rich, .fs-bundle-product__rich')) || null;
      }
      const target = trigger.closest('modal-opener')?.getAttribute('data-modal');
      if (!target || !/^#[A-Za-z][\w:.-]*$/.test(target)) return null;
      return this.ownerDocument.getElementById(target.slice(1))?.querySelector('.product-popup-modal__content-info') || null;
    }
    outside(event) {
      const rect = this.dialog.getBoundingClientRect();
      return event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom;
    }
    open(trigger) {
      if (this.dialog.open) return true;
      const source = this.sourceFor(trigger);
      if (!source) return false;
      const pdp = this.isPDP(trigger);
      const material = this.detailType(trigger) === 'material';
      // Cancel any previous quickview load before replacing its content or title.
      this.querySelector('fs-fit-wizard')?.close();
      this.dialog.classList.toggle('fs-chart-dialog--pdp', pdp);
      this.dialog.classList.toggle('fs-chart-dialog--material', material);
      if (pdp) this.dialog.removeAttribute('aria-describedby');
      else if (this.descriptionId) this.dialog.setAttribute('aria-describedby', this.descriptionId);
      const title = cleanText(trigger.textContent);
      this.scroll.setAttribute('aria-label', title);
      const fragment = this.copyChart(source, title, pdp && !material);
      this.content.replaceChildren(fragment);
      this.el('title').textContent = title;
      const empty = !cleanText(this.content.textContent) && !this.content.querySelector('img');
      this.el('empty').textContent = this.dialog.dataset.emptyLabel;
      this.el('empty').hidden = !empty;
      this.content.hidden = empty;
      this.setProduct(trigger);
      this.opener = trigger;
      this.parentDialog = trigger.closest('dialog');
      this.returnFocus = true;
      try { this.dialog.showModal(); } catch (_) {
        this.content.replaceChildren();
        this.opener = null;
        this.parentDialog = null;
        return false;
      }
      this.scrollState = { body: this.ownerDocument.body.style.overflow, html: this.ownerDocument.documentElement.style.overflow };
      this.ownerDocument.body.style.overflow = 'hidden';
      this.ownerDocument.documentElement.style.overflow = 'hidden';
      this.parentDialog?.addEventListener('close', this.onParentClose);
      this.scroll.scrollTop = 0;
      if (!pdp) this.querySelector('fs-fit-wizard')?.openFor(trigger);
      this.closeButton.focus({ preventScroll: true });
      return true;
    }
    setProduct(trigger) {
      const quickview = trigger.closest('fs-live-quickview, fs-bundle-product');
      const product = trigger.closest('product-info') || trigger.closest('.shopify-section')?.querySelector('product-info');
      const title = quickview?.querySelector('[data-fs-product-title]') || product?.querySelector('.product__title h1') || product?.querySelector('.product__title h2') || product?.querySelector('.product__title');
      const image = quickview?.querySelector('[data-fs-product-image]') || product?.querySelector('media-gallery .product__media img, media-gallery img');
      const src = image ? safeURL(image.currentSrc || image.getAttribute('src')) : '';
      this.el('product-title').textContent = cleanText(title?.textContent);
      this.el('product').hidden = !cleanText(title?.textContent);
      const photo = this.el('photo');
      photo.hidden = !src;
      photo.onerror = () => { photo.hidden = true; };
      if (src) photo.src = src;
      else photo.removeAttribute('src');
    }
    close(restoreFocus = true) {
      if (!this.dialog?.open) return;
      this.returnFocus = restoreFocus;
      this.dialog.close();
    }
    finishClose() {
      this.querySelector('fs-fit-wizard')?.close();
      const opener = this.opener;
      this.parentDialog?.removeEventListener('close', this.onParentClose);
      // When the underlying quickview closes first, its own handler has already
      // restored the page. Do not reinstate that quickview's obsolete scroll lock.
      if (this.scrollState && (!this.parentDialog || this.parentDialog.open)) {
        this.ownerDocument.body.style.overflow = this.scrollState.body;
        this.ownerDocument.documentElement.style.overflow = this.scrollState.html;
      }
      this.scrollState = null;
      this.parentDialog = null;
      this.opener = null;
      this.backdropStart = false;
      this.content?.replaceChildren();
      if (this.returnFocus && opener?.isConnected) opener.focus({ preventScroll: true });
      this.returnFocus = false;
    }
    nativeChart(match) {
      const doc = this.ownerDocument;
      const { chart, originalURL } = match;
      const section = doc.createElement('section');
      section.className = 'fs-chart-dialog__native';
      const label = chart.sourceTitleExact.join(' · ');
      section.setAttribute('aria-label', label);
      const scroll = doc.createElement('div');
      scroll.className = 'fs-chart-dialog__table-scroll';
      scroll.tabIndex = 0;
      scroll.setAttribute('role', 'region');
      scroll.setAttribute('aria-label', label);
      const table = doc.createElement('table');
      const caption = doc.createElement('caption');
      caption.textContent = label;
      table.append(caption);
      const head = doc.createElement('thead');
      const headerRow = doc.createElement('tr');
      chart.headersExact.forEach((value) => {
        const cell = doc.createElement('th');
        cell.scope = 'col';
        cell.textContent = value;
        headerRow.append(cell);
      });
      head.append(headerRow);
      table.append(head);
      const body = doc.createElement('tbody');
      [...(chart.confirmedAdditionalRows || []), ...chart.printedRowsExact].forEach((values) => {
        const row = doc.createElement('tr');
        values.forEach((value, index) => {
          const cell = doc.createElement(index === 0 ? 'th' : 'td');
          if (index === 0) cell.scope = 'row';
          cell.textContent = value === null ? '—' : String(value);
          if (value === null) cell.setAttribute('aria-label', 'Not provided in the original chart');
          row.append(cell);
        });
        body.append(row);
      });
      table.append(body);
      scroll.append(table);
      section.append(scroll);
      const unit = doc.createElement('p');
      unit.textContent = chart.unitStatementExact || 'Units are not specified in the original chart.';
      section.append(unit);
      chart.notesExact.forEach((text) => {
        const note = doc.createElement('p');
        note.textContent = text;
        section.append(note);
      });
      if (chart.measurementGuide === 'hoodie') {
        const guide = doc.createElement('figure');
        guide.className = 'fs-chart-dialog__measure';
        // Static instructional SVG only, never customer or catalog HTML.
        guide.innerHTML = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 300 175\" role=\"img\" aria-labelledby=\"hoodie-guide-title hoodie-guide-desc\">\n  <title id=\"hoodie-guide-title\">How to measure a hoodie laid flat</title>\n  <desc id=\"hoodie-guide-desc\">Back view. A is chest width, measured straight across from the bottom of one armpit to the other. B is center-back length, measured from the center of the back neck seam to the bottom hem, not from the hood or shoulder.</desc>\n  <defs>\n    <marker id=\"hoodie-arrow\" markerWidth=\"5\" markerHeight=\"5\" refX=\"2.5\" refY=\"2.5\" orient=\"auto-start-reverse\" markerUnits=\"userSpaceOnUse\"><path d=\"M0 0 5 2.5 0 5\" fill=\"none\" stroke=\"#a34e24\" stroke-width=\"1.2\"/></marker>\n  </defs>\n  <g fill=\"#f5f3ef\" stroke=\"#292929\" stroke-width=\"1.6\" stroke-linejoin=\"round\">\n    <path d=\"M127 38 102 44 86 58 63 130 83 137 106 91 108 160 192 160 194 91 217 137 237 130 214 58 198 44 173 38Z\"/>\n    <path d=\"m63 130-3 10 20 7 3-10M217 137l3 10 20-7-3-10M108 151h84M105 83l1 8M195 83l-1 8\" fill=\"none\"/>\n    <path d=\"M127 38c-1-17 10-26 23-26s24 9 23 26l-3 19c-12 8-28 8-40 0Z\"/>\n    <path d=\"M150 15v31m-20 11q20-9 40 0\" fill=\"none\" stroke=\"#7c7873\" stroke-width=\"1\"/>\n  </g>\n  <g fill=\"none\" stroke=\"#a34e24\" stroke-width=\"1.6\" marker-start=\"url(#hoodie-arrow)\" marker-end=\"url(#hoodie-arrow)\">\n    <path d=\"M108 91H192\"/>\n    <path d=\"M150 53V160\" stroke-dasharray=\"3 2\"/>\n  </g>\n  <g font-family=\"Arial, Helvetica, sans-serif\" fill=\"#292929\">\n    <rect x=\"120\" y=\"77\" width=\"16\" height=\"15\" rx=\"3\" fill=\"#fff\"/>\n    <text x=\"128\" y=\"88\" text-anchor=\"middle\" font-size=\"16\" font-weight=\"700\">A</text>\n    <rect x=\"153\" y=\"113\" width=\"16\" height=\"15\" rx=\"3\" fill=\"#fff\"/>\n    <text x=\"161\" y=\"124\" text-anchor=\"middle\" font-size=\"16\" font-weight=\"700\">B</text>\n  </g>\n</svg>\n";
        const caption = doc.createElement('figcaption');
        ['Lay the hoodie flat, back facing up.', 'A · Chest: measure straight across, armpit to armpit.', 'B · Length: center-back neck seam to bottom hem.'].forEach((text) => {
          const line = doc.createElement('p');
          line.textContent = text;
          caption.append(line);
        });
        guide.append(caption);
        section.append(guide);
        const confirmed = doc.createElement('p');
        confirmed.className = 'fs-chart-dialog__confirmed';
        confirmed.textContent = 'XS measurements confirmed by Fullstop.';
        section.append(confirmed);
      }
      const link = doc.createElement('a');
      link.className = 'fs-chart-dialog__original';
      link.href = originalURL;
      link.target = '_blank';
      link.rel = 'noopener noreferrer';
      link.textContent = 'View original chart and measuring guide (opens in a new tab)';
      section.append(link);
      return section;
    }
    copyChart(source, title, renderNative = false) {
      const doc = this.ownerDocument;
      const fragment = doc.createDocumentFragment();
      const recognized = new Map();
      if (renderNative) source.querySelectorAll('img').forEach((image) => {
        const match = nativeChartFor(image.currentSrc || image.getAttribute('src') || image.getAttribute('data-src'));
        if (match) recognized.set(image, match);
      });
      const firstHeading = source.matches('.product-popup-modal__content-info') ? source.querySelector('h1, h2, h3') : null;
      const copy = (node, parent) => {
        if (node.nodeType === 3) { parent.append(doc.createTextNode(node.textContent)); return; }
        if (node.nodeType !== 1 || blockedTags.has(node.tagName)) return;
        if (node === firstHeading && cleanText(node.textContent).toLowerCase() === title.toLowerCase()) return;
        if (!allowedTags.has(node.tagName)) { Array.from(node.childNodes).forEach((child) => copy(child, parent)); return; }
        if (recognized.has(node)) { parent.append(this.nativeChart(recognized.get(node))); return; }
        // A native table needs a block container, not a source image's paragraph/link.
        const wrapsNative = Array.from(recognized.keys()).some((image) => node.contains(image));
        const tag = wrapsNative && ['P', 'A', 'SPAN', 'H1', 'H2', 'H3', 'H4', 'H5', 'H6'].includes(node.tagName)
          ? 'div' : /^H[1-6]$/.test(node.tagName) ? 'h3' : node.tagName.toLowerCase();
        const element = doc.createElement(tag);
        if (tag === 'img') {
          const src = safeURL(node.currentSrc || node.getAttribute('src') || node.getAttribute('data-src'));
          if (!src) return;
          element.src = src;
          element.alt = node.getAttribute('alt') || '';
          element.loading = 'eager';
          element.decoding = 'async';
          element.addEventListener('error', () => {
            if (!element.isConnected || element.hidden) return;
            element.hidden = true;
            const error = doc.createElement('p');
            error.className = 'fs-chart-dialog__image-error';
            error.textContent = this.dialog.dataset.imageErrorLabel;
            element.after(error);
          }, { once: true });
        }
        if (tag === 'a') {
          const href = safeURL(node.getAttribute('href'));
          if (href) { element.href = href; element.target = '_blank'; element.rel = 'noopener noreferrer'; }
        }
        if (tag === 'td' || tag === 'th') {
          ['colspan', 'rowspan'].forEach((name) => {
            const value = node.getAttribute(name);
            if (/^[1-9]\d?$/.test(value || '')) element.setAttribute(name, value);
          });
          const scope = node.getAttribute('scope');
          if (['col', 'row', 'colgroup', 'rowgroup'].includes(scope)) element.setAttribute('scope', scope);
        }
        Array.from(node.childNodes).forEach((child) => copy(child, element));
        if (tag === 'table') {
          const scroll = doc.createElement('div');
          scroll.className = 'fs-chart-dialog__table-scroll';
          scroll.tabIndex = 0;
          scroll.setAttribute('role', 'region');
          scroll.setAttribute('aria-label', title);
          scroll.append(element);
          parent.append(scroll);
        } else parent.append(element);
      };
      Array.from(source.childNodes).forEach((node) => copy(node, fragment));
      return fragment;
    }
  }
  customElements.define('fs-chart-dialog', FsChartDialog);
})();


